<template>
  <div class="section maps-1">
    <div class="container">
      <h3 class="where-you-can-find-text">
        Where you can find us
  
      </h3>
      <div class="row">
        <div class="col-12">
          <div class="map-cnt">
            <div class="overlay-cnt">
              <div class="our-location-container">
                <span class="sub-text">
                  <b>Italy</b>
                  <hr />
                  <a href="#" @click.prevent="changeMapLocation('Italy')">
                    Via Della Posta N.8<br />20123 Milano MI
                  </a>
                </span>
                <!-- <span class="sub-text">
                  <b>Romania</b>
                  <hr />
                  <a href="#" @click.prevent="changeMapLocation('Romania')">
                    Turnul Magurele 270 D<br />Cavar Center Corp C, et 2<br />041713
                    Bucharest B
                  </a>
                </span> -->
              </div>
            </div>
            <iframe
              id="map"
              src=""
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen="true"
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurLocations",
  components: {},

  data() {
    return {
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
      lang: localStorage.getItem("language") ?? "en",
      loadingComplete: false,
    };
  },
  computed: {},
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
    this.$store.dispatch("api/createAuth");
  },
  methods: {
    changeMapLocation(country) {
      const italyMap =
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1173.9970103340125!2d9.187233149516866!3d45.46448614620329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c16d1d992d3b%3A0x6b70cc0a36b7c4ab!2sVia%20della%20Posta%2C%208%2C%2020123%20Milano%20MI!5e0!3m2!1it!2it!4v1676460593549!5m2!1it!2it";
      const romaniaMap =
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2851.6446973022544!2d26.124678315853437!3d44.378885979103124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1fe0e0bcb6fc5%3A0x20154044ea6e69ae!2sStrada%20Turnu%20M%C4%83gurele%20270d%2C%20Bucure%C8%99ti%20041713%2C%20Romania!5e0!3m2!1it!2it!4v1676461661720!5m2!1it!2it";
      const map = document.getElementById("map");

      if (country === "Italy") {
        map.src = italyMap;
      } else if (country === "Romania") {
        map.src = romaniaMap;
      }
    },
  },
  mounted() {
    this.changeMapLocation("Italy");
  },
};
</script>

<style scoped>
.container {
  padding: 40px 0px;
  max-width: 1200px;
}

iframe {
  border-radius: 15px;
}

.section.maps-1 {
  display: block;
  padding: 0 0 6rem;
}

.title {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.45rem;
}

.where-you-can-find-text {
  font-weight: 600;
  font-size: 32px;
  line-height: 1.4rem;
  color: #25354d;
  margin: 40px 0px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.where-you-can-find-icon {
  max-width: 30px;
  max-height: 30px;
  object-fit: contain;
  line-height: 1.2;
  margin-left: 10px;
}
.title-subTitle-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
}

.our-location-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.title-subTitle-container .sub-text {
  margin-top: 10px;
  font-family: "Montserrat", sans-serif;
}

.sub-text a {
  font-family: "Montserrat", sans-serif;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
  opacity: 0.8;
}

.our-location-container .sub-text {
  margin-top: 10px;
}

.section.maps-1 .map-cnt {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  height: 500px;
  border-radius: 15px;
  padding: 10px;
  overflow: hidden;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
}

.section.maps-1 .map-cnt .map-a {
  display: block;
  width: 50%;
}

.section.maps-1 .map-cnt .map-a > img {
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
  width: 100%;
  height: 450px;
}

.section.maps-1 .map-cnt .overlay-cnt {
  position: relative;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  color: #666;
  z-index: 1;
}

.section.maps-1 .map-cnt .overlay-cnt::before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.section.maps-1 .map-cnt .overlay-cnt .btn,
.section.maps-1 .map-cnt .overlay-cnt .sub-text,
.section.maps-1 .map-cnt .overlay-cnt .title {
  text-align: center;
  z-index: 3;
}

@media (max-width: 992px) {
  .container {
    padding: 0px 15px;
  }

  .section.maps-1 .map-cnt {
    flex-wrap: wrap;
  }

  .section.maps-1 .map-cnt .overlay-cnt {
    width: 100%;
    height: 250px;
    border-right: 0;
  }

  .section.maps-1 .map-cnt .map-a {
    width: 100%;
  }

  .our-location-container {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    width: 100%;
  }

  .sub-text a {
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    opacity: 0.8;
  }
}

@media (max-width: 768px) {
  .where-you-can-find-text {
    font-weight: 600;
    font-size: 22px;
    line-height: 1.4rem;
    color: #25354d;
    margin: 40px 0px;
    align-items: center;
    display: flex;
    justify-content: center;
  }
}
</style>
